// Module
var code = `<!-- clProse — structured prose.
     Data shape: { content: [ "paragraph string (markdown-parsed HTML)", ... ] }
     Each string in content is rendered as a <p>. DomElementTemplate's {{.}} emits
     the string as-is, so markdown-parsed HTML (e.g., <strong>, <em>, <code>, <a>)
     flows through correctly without needing a triple-mustache. -->
<div class="block-cl-prose">
  {{#content}}<p>{{.}}</p>{{/content}}
</div>
`;
// Exports
module.exports = code;